<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center flex-fill gap-3">
        <div class="d-flex ali-items-center gap-2">
          <h6 class="modal-title mb-0" i18n>Messaging Settings</h6>
        </div>
        <div class="flex-fill"></div>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="fas fa-times"></span>
      </a>
    </div>
    <ul class="nav top-navbar bg-white border-bottom" role="tablist">
      <li [class.active]="activeTab === tabs.Channels">
        <a href="javascript:;" (click)="activeTab = tabs.Channels"> <ng-container i18n>Channels</ng-container> </a>
      </li>
      <li [class.active]="activeTab === tabs.Charges" *ngIf="isMessagingSubscribed">
        <a href="javascript:;" (click)="activeTab = tabs.Charges">
          <ng-container i18n>Credit Recharge</ng-container>
        </a>
      </li>
    </ul>
    <div class="modal-body">
      <ng-container [ngSwitch]="activeTab">
        <ng-template [ngTemplateOutlet]="channels" *ngSwitchCase="tabs.Channels"></ng-template>
        <ng-template [ngTemplateOutlet]="charges" *ngSwitchCase="tabs.Charges"></ng-template>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #channels>
  <div class="d-grid gap-3" style="grid-template-columns: repeat(auto-fit, minmax(350px, 1fr))">
    <div *ngFor="let item of items" class="container-box p-3">
      <div class="d-flex align-items-center mb-2">
        <div class="text-bold d-flex align-items-center gap-2">
          <img [src]="item.logo" alt="" height="25" />
          {{ item.label }}
          <span class="text-muted text-sm fw-normal" *ngIf="!item.isSubscriptionRequired" i18n>(Free)</span>
          <app-page-help [articleId]="item.articleId"></app-page-help>
          <i
            *ngIf="item.id === types.SMS"
            class="fal fa-info-circle"
            matTooltip="SMS feature works only for rentals connected via API channel"
            i18n-matTooltip
          ></i>
        </div>
        <div class="flex-fill"></div>
        <button class="btn btn-secondary-info" *ngIf="!item.isProdReady && isProduction" disabled i18n>
          Coming Soon
        </button>
        <ng-template
          *ngIf="item.isProdReady || !isProduction"
          [ngTemplateOutlet]="connectTpl"
          [ngTemplateOutletContext]="{ item: item }"
        ></ng-template>
      </div>
      <div>{{ item.description }}</div>

      <div *ngIf="channelConfig?.[item.channel]?.enabled && item.channel === 'facebook' && facebookPages?.length > 0">
        <div class="facebook-page-header" i18n>Subscribed to pages:</div>
        <div *ngFor="let page of facebookPages" class="facebook-page">{{ page.name }}</div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #charges>
  <app-sms-auto-credit-recharge class="container-box p-3"></app-sms-auto-credit-recharge>
</ng-template>

<ng-template #connectTpl let-item="item">
  <ng-container *ngIf="item.isSubscriptionRequired && !isMessagingSubscribed">
    <button
      (click)="onSubscribe()"
      type="button"
      class="btn btn-secondary-info"
      [disabled]="1 | isReadonlyRole"
      matTooltip="SMS feature works only for rentals connected via API channel"
      i18n-matTooltip
      [matTooltipDisabled]="item.id !== types.SMS"
    >
      <ng-container i18n>Subscribe</ng-container>
    </button>
  </ng-container>
  <ng-container *ngIf="item.isSubscriptionRequired && isMessagingSubscribed">
    <button type="button" class="btn btn-primary"><ng-container i18n>Subscribed</ng-container></button>
  </ng-container>

  <ng-container *ngIf="!item.isSubscriptionRequired && !item.oauth">
    <button
      type="button"
      matTooltip="WhatsApp is free to use."
      [matTooltipDisabled]="item.id !== types.Whatsapp"
      class="btn btn-primary"
    >
      <ng-container i18n>Subscribed</ng-container>
    </button>
  </ng-container>

  <ng-container *ngIf="item.oauth">
    <button
      (click)="onConnect(item.channel)"
      type="button"
      class="btn btn-secondary-info"
      [disabled]="1 | isReadonlyRole"
      *ngIf="!channelConfig?.[item.channel]?.enabled"
    >
      <ng-container i18n>Connect</ng-container>
    </button>
    <button
      (click)="onDisconnect(item.channel)"
      type="button"
      class="btn btn-secondary-danger"
      [disabled]="1 | isReadonlyRole"
      *ngIf="channelConfig?.[item.channel]?.enabled"
    >
      <ng-container i18n>Disconnect</ng-container>
    </button>
  </ng-container>
</ng-template>
